import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import SignInButton from '../components/SigninButton';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom'
import { useMsal } from "@azure/msal-react";
import '../style/login.css'
import { selectRedirectUrl } from '../store/features/authSlice';
import { SESSION_STORAGE_REDIRECT_KEY, VALID_REDIRECT_PREFIXES } from '../constants';

const Login = () => {
  const navigate = useNavigate()
  const { accounts } = useMsal();
  const redirectUrl = useSelector(selectRedirectUrl)

  
  useEffect(() => {
    if (accounts.length > 0) {
      let intendedPath: string | null = null
      try {
        intendedPath = sessionStorage.getItem(SESSION_STORAGE_REDIRECT_KEY)
        sessionStorage.removeItem(SESSION_STORAGE_REDIRECT_KEY)
      } catch {
        // sessionStorage may be disabled (e.g., corporate policy, private browsing)
      }

      // Narrow to a non-null string before entering the .some() callback
      // This avoids the TS18047 closure-narrowing gap entirely
      const path = intendedPath ?? ''
      const isValidPath = path.length > 0 &&
        VALID_REDIRECT_PREFIXES.some(prefix => path.startsWith(prefix))

      // Fallback chain: validated stored path → Redux redirect → hard default
      const destination = isValidPath ? path : (redirectUrl || '/home')
      navigate(destination)
    }
  }, [accounts, navigate, redirectUrl])

    return (
      <Box className="login-canvas" sx={{ height: '90vh' }} 
        display="flex"
        alignItems="center"
        flexDirection="column"
        justifyContent="center" >
        <SignInButton />
      </Box>
    // </Box>
    )
}

export default Login